import { Link } from "react-router-dom";

const ENTRIES = [
  {
    to: "/category/movie",
    label: "电影",
    desc: "院线大片 · 高分佳作 · 全球精选",
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20dark%20vintage%20cinema%20hall%20with%20warm%20orange%20projector%20light%20deep%20dark%20toned%20interior%20atmospheric%20glow%20film%20still%20aesthetic%20high%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=800&height=500&seq=wm-entry-movie&orientation=landscape",
    count: "12 部精选",
  },
  {
    to: "/category/tv",
    label: "电视剧",
    desc: "热播剧集 · 口碑佳剧 · 一网打尽",
    icon: "ri-tv-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20cozy%20dark%20living%20room%20tv%20glow%20at%20night%20warm%20orange%20light%20deep%20dark%20toned%20interior%20atmospheric%20film%20still%20aesthetic%20high%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=800&height=500&seq=wm-entry-tv&orientation=landscape",
    count: "8 部精选",
  },
];

export default function CategoryEntry() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      {ENTRIES.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group relative h-44 md:h-52 rounded-lg overflow-hidden bg-background-800 block"
        >
          <img
            src={entry.image}
            alt={`${entry.label}分类入口`}
            title={`进入${entry.label}频道`}
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-950/95 via-background-950/60 to-background-950/20"></div>
          <div className="relative z-10 h-full flex flex-col justify-center px-6 md:px-8">
            <span className="w-11 h-11 rounded-lg bg-primary-500 flex items-center justify-center mb-3">
              <i className={`${entry.icon} text-2xl text-background-50`}></i>
            </span>
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-1.5">
              {entry.label}
            </h3>
            <p className="text-sm text-foreground-300 mb-3">{entry.desc}</p>
            <span className="flex items-center gap-1 text-sm text-primary-400 font-medium">
              立即进入 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </div>
          <span className="absolute top-4 right-4 z-10 px-2.5 py-1 rounded-md bg-background-950/70 border border-background-700 text-foreground-200 text-xs">
            {entry.count}
          </span>
        </Link>
      ))}
    </div>
  );
}